import { store } from '../store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import { ReturnsEnum } from '../enums/modules/routes'
import ReturnsRoot from '../components/micro-front-ends/Returns'

// Vuex Modules to load
const ReturnsModule = () => import(/* webpackChunkName: "Returns" */ '../store/modules/returns')

// Components
const CreateReturn = () =>
  import(/* webpackChunkName: "ReturnDetails" */ '@/components/createReturn/CreateReturn')

const dynamicModuleRegistrationReturnsArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'returns',
    module: ReturnsModule,
    store,
    modulePath: 'returns'
  }
}

export const returnsRouteResolver = (to, _from, next) => {
  // Use this because /returns/<anything> will resolve to returnDetails even if
  // it is not an id. So we need to check if it is a number and route to the
  // right spot
  if (isNaN(Number(to.params.returnId))) next({ ...to, name: ReturnsEnum.Returns })
  else next()
}

export const ReturnMFERoutes = [
  {
    path: '/returns/create',
    component: CreateReturn,
    name: ReturnsEnum.CreateReturn,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(dynamicModuleRegistrationReturnsArgs()).then(() => next())
    },
    meta: { domain: ReturnsEnum.Returns }
  },
  {
    path: '/returns',
    component: ReturnsRoot,
    name: ReturnsEnum.Returns,
    meta: { domain: ReturnsEnum.Returns, showSideNav: true },
    redirect: '/returns/all',
    children: [
      {
        path: '*',
        component: ReturnsRoot,
        name: ReturnsEnum.Returns,
        meta: { domain: ReturnsEnum.Returns, showSideNav: true }
      }
    ]
  }
]
